import { useRouter, useRoute } from "vue-router";

export function useRouterNavigation() {
  const router = useRouter();
  const route = useRoute();

  /**
   * Navigate while preserving existing query parameters
   * @param to - Route location
   * @param preserveQuery - Whether to preserve current query params (default: true)
   */
  const navigateWithQuery = (
    to: {
      name: string;
      params?: Record<string, any>;
      query?: Record<string, any>;
    },
    preserveQuery = true
  ) => {
    const routeObject = {
      name: to.name,
      params: to.params ?? {},
      query: preserveQuery ? { ...route.query, ...to.query } : to.query ?? {},
    };

    return router.push(routeObject);
  };

  /**
   * Helper to get route object with preserved query params
   * @param routeName - Route name
   * @param params - Route params
   * @param additionalQuery - Additional query params to add/override
   */
  const getRouteWithQuery = (
    routeName: string,
    params?: Record<string, any>,
    additionalQuery?: Record<string, any>
  ) => {
    return {
      name: routeName,
      params: params ?? {},
      query: { ...route.query, ...additionalQuery },
    };
  };

  return {
    navigateWithQuery,
    getRouteWithQuery,
  };
}
